import styles from './MobileItem.module.scss';

import cx from 'classnames';
import React from 'react';

import { EnhancedMedia } from 'components/EnhancedMedia/EnhancedMedia';
import type { IEntryProp } from '../../IEntries';
import { TextBlock } from '../../TextBlock/TextBlock';

export const MobileItem: React.FC<IEntryProp> = ({ entry, className, backgroundColor, first, ...props }) => {
  if (!entry?.fields) return null;

  const { topic, isMediaMasked } = entry.fields;

  if (!topic?.fields) {
    return null;
  }

  const { video } = topic.fields;

  return (
    <div className={cx(styles.mobile, className)} {...props}>
      <div
        style={{ backgroundColor }}
        className={cx(styles.mediaWrapper, {
          [styles.mediaWrapperMasked]: isMediaMasked,
        })}
      >
        <EnhancedMedia
          preferHeight={!video}
          preferWidth={!!video}
          autoPlay
          muted
          loop
          className={styles.media}
          entry={topic}
        />
      </div>
      <TextBlock className={styles.textWrapper} entry={topic} />
    </div>
  );
};
